import SvgIcon from "@mui/material/SvgIcon";

import "./style.scss";
import { ReactComponent as MonitorIcon } from "../../../assets/monitor.icon.svg";
import HeaderLayout from "../../../components/layout/header-layout.comp";

const SwitchScreenView = () => {
    return (
        <HeaderLayout blurHeader={false}>
            <div className="switch-screen-view">
                <SvgIcon
                    className="switch-screen-view__icon"
                    component={MonitorIcon}
                    inheritViewBox
                />
                <span className="switch-screen-view__title">
                    Please switch
                    <br></br>
                    to larger screen
                </span>
                <span className="switch-screen-view__description">
                    MBA Dashboard is not suitable
                    <br></br>
                    for smartphone screens
                </span>
            </div>
        </HeaderLayout>
    );
};

export default SwitchScreenView;
